.container {
  color: var(--text-color);
  font-size: 1rem;
  line-height: 1.75;
}
.container a {
  color: var(--text-color);
  text-decoration: underline;
  font-weight: 500;
}
.container strong {
  color: var(--text-color);
  font-weight: 600;
}
.container ol[type="A"] {
  --list-counter-style: upper-alpha;
}
.container ol[type="a"] {
  --list-counter-style: lower-alpha;
}
.container ol[type="I"] {
  --list-counter-style: upper-roman;
}
.container ol[type="i"] {
  --list-counter-style: lower-roman;
}
.container ol[type="1"] {
  --list-counter-style: decimal;
}
.container ol > li {
  position: relative;
  padding-left: 1.75em;
}
.container ol > li::before {
  content: counter(list-item, var(--list-counter-style, decimal)) ".";
  position: absolute;
  font-weight: 400;
  color: var(--sub-color);
  left: 0;
}
.container ul > li {
  position: relative;
  padding-left: 1.75em;
}
.container ul > li::before {
  content: "";
  position: absolute;
  background-color: var(--sub-color);
  border-radius: 50%;
  width: 0.375em;
  height: 0.375em;
  top: calc(0.875em - 0.1875em);
  left: 0.25em;
}
.container hr {
  border-color: var(--sub-color);
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}
.container blockquote {
  font-weight: 500;
  font-style: italic;
  color: var(--text-color);
  border-left-width: 0.25rem;
  border-left-color: var(--sub-color);
  quotes: "\201C""\201D""\2018""\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-left: 1em;
}
.container blockquote p:first-of-type::before {
  content: open-quote;
}
.container blockquote p:last-of-type::after {
  content: close-quote;
}
.container h1 {
  color: var(--text-color);
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}
.container h2 {
  color: var(--text-color);
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}
.container h3 {
  color: var(--text-color);
  font-weight: 600;
  font-size: 1.25em;
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}
.container h4 {
  color: var(--text-color);
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}
.container figure figcaption {
  color: var(--sub-color);
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}
.container code {
  color: var(--text-color);
  font-weight: 600;
  font-size: 0.875em;
}
.container code::before {
  content: "`";
}
.container code::after {
  content: "`";
}
.container a code {
  color: var(--text-color);
}
.container pre {
  color: var(--sub-color);
  background-color: var(--text-color);
  overflow-x: auto;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  padding-right: 1.1428571em;
  padding-bottom: 0.8571429em;
  padding-left: 1.1428571em;
}
.container pre code {
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: 400;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}
.container pre code::before {
  content: none;
}
.container pre code::after {
  content: none;
}
.container table {
  width: 100%;
  table-layout: auto;
  text-align: left;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}
.container thead {
  color: var(--text-color);
  font-weight: 600;
  border-bottom-width: 1px;
  border-bottom-color: var(--sub-color);
}
.container thead th {
  vertical-align: bottom;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}
.container tbody tr {
  border-bottom-width: 1px;
  border-bottom-color: var(--sub-color);
}
.container tbody tr:last-child {
  border-bottom-width: 0;
}
.container tbody td {
  vertical-align: top;
  padding-top: 0.5714286em;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}
.container p {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.container img {
  margin-top: 2em;
  margin-bottom: 2em;
}
.container video {
  margin-top: 2em;
  margin-bottom: 2em;
}
.container figure {
  margin-top: 2em;
  margin-bottom: 2em;
}
.container figure > * {
  margin-top: 0;
  margin-bottom: 0;
}
.container h2 code {
  font-size: 0.875em;
}
.container h3 code {
  font-size: 0.9em;
}
.container ol {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.container ul {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
.container li {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
.container > ul > li p {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.container > ul > li > :first-child {
  margin-top: 1.25em;
}
.container > ul > li > :last-child {
  margin-bottom: 1.25em;
}
.container > ol > li > :first-child {
  margin-top: 1.25em;
}
.container > ol > li > :last-child {
  margin-bottom: 1.25em;
}
.container ol ol,
.container ol ul,
.container ul ol,
.container ul ul {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
.container hr + * {
  margin-top: 0;
}
.container h2 + * {
  margin-top: 0;
}
.container h3 + * {
  margin-top: 0;
}
.container h4 + * {
  margin-top: 0;
}
.container thead th:first-child {
  padding-left: 0;
}
.container thead th:last-child {
  padding-right: 0;
}
.container tbody td:first-child {
  padding-left: 0;
}
.container tbody td:last-child {
  padding-right: 0;
}
.container > :first-child {
  margin-top: 0;
}
.container > :last-child {
  margin-bottom: 0;
}
.container a {
  color: var(--main-color);
}
.container a code {
  color: var(--main-color);
}
